//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChangeDialog from "../../Cooperative/Management/ChangeDialog";
export default {
  name: "VillageManageList",
  data() {
    return {
      filterForm: {
        provinceId: "",
        cityId: "",
        areaId: "",
        townId: "",
        villageId: "",
        fullName: "",
        personName: "",
        businessZoneId: "", //业务区域id
        businessPersonId: "", //业务负责人id
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      tableData: [],
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], //业务负责人数据
      showDialog: false, // 弹窗
      multipleSelection: [], // 多选
      provinceList: [],
      cityList: [],
      areaList: [],
      countyList: [],
      villageList: [],
    };
  },
  components: { ChangeDialog },
  filters: {},
  watch: {
    checkedZone(newVal) {
      this.filterForm.businessPersonId = "";
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  created() {
    this.getVillageList();
    this.getBusinessZoneData();
    this.getSelectedCityOptions(1, "provinceList");
  },
  mounted() {},
  methods: {
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.page = 1;
      this.getVillageList();
    },
    //获取列表数据
    getVillageList() {
      let params = Object.assign({}, this.filterForm, {
        currentPage: this.pagination.page,
        pageSize: this.pagination.size,
      });
      this.$http.village.villageListFilter(params).then((res) => {
        this.tableData = res.data.content;
        if (this.pagination.page == 1)
          this.pagination.total = res.data.recordTotal;
      });
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getVillageList();
    },
    /**
     * @description: 更改区域或业务员
     * @Author: yangsibo
     * @Date: 2022-05-18 15:27:45
     * @param id
     * @return {*}
     */
    changeAreaOrSalesman() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "请先勾选要操作的数据",
          duration: 2000,
        });
        return;
      }
      this.showDialog = true;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
    /**
     * @description: 多选
     * @Author: yangsibo
     * @Date: 2022-05-18 14:56:05
     * @param val
     */
    selectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * @description: 查看村集体
     * @Author: quwandong
     * @Date: 2022-05-18 15:27:45
     * @param row
     */
    lookDetail(row) {
      const routeResolve = this.$router.resolve({
        path: "/village/trustee/contract",
        query: {
          $businessId: row.id,
          $businessName: row.fullName,
          $businessType: "_blank",
          $businessAccountId: row.accountId,
          $backPath: this.$route.path,
        },
      });

      window.open(routeResolve.href, "_blank");
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @Author: yangsibo
     * @Date: 2022-05-09 10:31:13
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChange(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.filterForm.cityId = "";
          this.filterForm.areaId = "";
          this.filterForm.townId = "";
          this.filterForm.villageId = "";
          this.cityList = [];
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.filterForm.areaId = "";
          this.filterForm.townId = "";
          this.filterForm.villageId = "";
          this.areaList = [];
          this.countyList = [];
          this.villageList = [];
          list = "cityList";
          break;
        case "countyList":
          this.filterForm.townId = "";
          this.filterForm.villageId = "";
          this.countyList = [];
          this.villageList = [];
          list = "areaList";
          break;
        case "villageList":
          this.filterForm.villageId = "";
          this.villageList = [];
          list = "countyList";
          break;
        case "":
          list = "villageList";
          break;
        default:
          break;
      }
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: yangsibo
     * @Date: 2022-05-09 10:16:19
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
      } catch (error) {}
    },
  },
};
